const state = { images: {} }

export const mutations = {
  setImage(state, image) {
    Vue.$set(state.images, image.url, image.payload)
  },
}

export const actions = {
  fetch({ state, commit }, url) {
    if (state.images[url] !== undefined) return null

    commit('setImage', { url, payload: null })

    return Vue.$http.get(url, { responseType: 'arraybuffer' }).then(response => {
      commit('setImage', {
        url,
        payload: `data:${response.headers['content-type']};base64,${Buffer.from(
          response.data,
          'binary'
        ).toString('base64')}`,
      })
    })
  },
}

export default {
  state,
  mutations,
  actions,
  namespaced: true,
}
